import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function Loading() {
    return (
        <div role="status" className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
            <FontAwesomeIcon icon={faSpinner} spin={true} fontSize="40px" color="gray" />
        </div>
    )
}

export function getLoadingOpacity(isLoading: boolean) {
    return isLoading ? "opacity-0" : "opacity-100";
}